// Matches the mark MUI's FormLabel draws for a required field, and like it stays out of the accessible name.
const RequiredMark = () => <span aria-hidden="true">&thinsp;*</span>;

export default RequiredMark;
